module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/card/card.html
// module id = 717
// module chunks = 0